import React from "react";
//import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "app/context/useAuth";
import Forbidden from "shared/ui/Forbidden";

export const ProtectedRoute = ({
  children,
  access,
}: {
  children: JSX.Element;
  access?: boolean;
}) => {
  const { token } = useAuth();
  //const location = useLocation();

  if (!token || access === false) {
    return <Forbidden />;
    //return <Navigate to="/auth" replace state={{ from: location }} />;
  }

  return children;
};
